export default async function ProsumerHome() {
  const { gsap, ScrollTrigger } = await import("gsap/all")

  // Animation
  gsap.registerPlugin(ScrollTrigger)

  gsap.config({
    force3D: "auto",
    autoSleep: 60,
  })

  // Animation: Slides
  const homeSlides = document.querySelector(".home--slides")
  if (homeSlides) {
    const tlSlides = gsap.timeline({
      repeat: "0",
      autoRemoveChildren: true,
      scrollTrigger: {
        trigger: ".home--slides",
        start: "top center",
      },
    })
    tlSlides.from("#sa--get", { duration: 0.5, opacity: "0" }, 0)
    tlSlides.from("#sa--alexa-device", { duration: 0.5, y: "50", opacity: "0" })
    tlSlides.from("#sa--alexa", { duration: 0.5, opacity: "0" })
    tlSlides.from("#sa--talking", { duration: 0.25, opacity: "0" })
    tlSlides.from("#sa--to", { duration: 0.25, opacity: "0" })
    tlSlides.from("#sa--gmail", {
      duration: 0.25,
      marginTop: "50",
      opacity: "0",
    })
    tlSlides.from("#sa--drive", {
      duration: 0.25,
      marginTop: "50",
      opacity: "0",
    })
    tlSlides.from("#sa--calendar", {
      duration: 0.25,
      marginTop: "50",
      opacity: "0",
    })
    tlSlides.addLabel("slide-01-end")
    tlSlides.from(
      "#sa--google-apps",
      { duration: 0.5, opacity: "0" },
      "slide-01-end"
    )
    tlSlides.to("#home--slide-01", { duration: 0.5, opacity: "0" }, "+=1")
    tlSlides.to("#home--slide-02", { opacity: "1" })
    tlSlides.addLabel("slide-02-start")
    tlSlides.from(
      "#sp--bulb",
      { duration: 0.5, opacity: "0" },
      "slide-02-start"
    )
    tlSlides.from("#sp--philips", { duration: 0.5, opacity: "0" }, "-=0.25")
    tlSlides.from("#sp--when", { duration: 0.5, opacity: "0" })
    tlSlides.from("#sp--sunrise-sunset-logo", {
      duration: 0.5,
      y: "50",
      opacity: "0",
    })
    tlSlides.from(
      "#sp--sunrise-sunset",
      { duration: 0.5, opacity: "0" },
      "-=0.25"
    )
    tlSlides.from(
      "#sp--sunset",
      { duration: 0.5, y: "50", opacity: "0" },
      "-=0.25"
    )
    tlSlides.to("#home--slide-02", { duration: 0.5, opacity: "0" }, "+=1")
    tlSlides.to("#home--slide-03", { opacity: "1" })
    tlSlides.addLabel("slide-03-start")
    tlSlides.from(
      "#se--send",
      { duration: 0.5, opacity: "0" },
      "slide-03-start"
    )
    tlSlides.from("#se--evernote-logo", {
      duration: 0.3,
      y: "-20",
      opacity: "0",
    })
    tlSlides.from("#se--evernote", { duration: 0.5, opacity: "0" }, "-=0.2")
    tlSlides.from("#se--to", { duration: 0.5, opacity: "0" })
    tlSlides.from("#se--slack-logo", { duration: 0.3, y: "-20", opacity: "0" })
    tlSlides.from("#se--slack", { duration: 0.5, opacity: "0" }, "-=0.2")
  }

  // Animation: Logos
  const gridLogos = document.querySelector(".holder--grid--logos")
  if (gridLogos) {
    const tlLogos = gsap.timeline({
      scrollTrigger: {
        trigger: ".holder--grid--logos",
        start: "top center",
      },
    })
    tlLogos.from(".grid--logo", {
      duration: 0.5,
      opacity: "0",
      y: "50",
      stagger: {
        amount: 1.25,
      },
    })
  }

  // Animation: Connect
  const gridConnect = document.querySelector(".grid--connect__image-1")
  if (gridConnect) {
    const tlConnect1 = gsap.timeline({
      scrollTrigger: {
        trigger: ".grid--connect__image-1",
        start: "top 1000px center",
      },
    })
    tlConnect1.from(".grid--connect__image-1", {
      duration: 0.5,
      y: "100",
      opacity: 0,
    })
    tlConnect1.from(
      ".grid--connect__copy-1",
      {
        duration: 0.5,
        y: "100",
        opacity: 0,
      },
      "-=0.25"
    )

    const tlConnect2 = gsap.timeline({
      scrollTrigger: {
        trigger: ".grid--connect__image-2",
        start: "top 1000px center",
      },
    })
    tlConnect2.from(".grid--connect__image-2", {
      duration: 0.5,
      y: "100",
      opacity: 0,
    })
    tlConnect2.from(
      ".grid--connect__copy-2",
      {
        duration: 0.5,
        y: "100",
        opacity: 0,
      },
      "-=0.25"
    )

    const tlConnect3 = gsap.timeline({
      scrollTrigger: {
        trigger: ".grid--connect__image-3",
        start: "top 1000px center",
      },
    })
    tlConnect3.from(".grid--connect__image-3", {
      duration: 0.5,
      y: "100",
      opacity: 0,
    })
    tlConnect3.from(
      ".grid--connect__copy-3",
      {
        duration: 0.5,
        y: "100",
        opacity: 0,
      },
      "-=0.25"
    )
  }

  // Animation: home pro
  const homePro = document.querySelector(".home--pro")
  if (homePro) {
    const tlPro = gsap.timeline({
      scrollTrigger: {
        trigger: ".home--pro",
        start: "top 500px center",
      },
    })
    tlPro.from(".home--pro--bg", {
      duration: 0.5,
      x: "-100",
    })
  }

  // Animation: Logos
  const gridQuad = document.querySelector(".grid--quad--btns")
  if (gridQuad) {
    const tlQuad = gsap.timeline({
      scrollTrigger: {
        trigger: ".grid--quad--btns",
        start: "top 700px center",
      },
    })
    tlQuad.from(".btn--quad", {
      duration: 0.5,
      opacity: "0",
      y: "50",
      stagger: {
        amount: 0.25,
      },
    })
  }

  // Animation: Circles
  const gridCircle = document.querySelector(".grid--circle")
  if (gridCircle) {
    const tlCirclesContent = gsap.timeline({
      scrollTrigger: {
        trigger: ".grid--circle",
        start: "top center",
      },
    })
    tlCirclesContent.from(".grid--circle .grid-1", { opacity: "0" })
    tlCirclesContent.from(".grid--circle .grid-4", { opacity: "0" })
    tlCirclesContent.from(".grid--circle .grid-5", { opacity: "0" })
    tlCirclesContent.from(".grid--circle .grid-2", { opacity: "0" })

    const tlCircles = gsap.timeline({
      scrollTrigger: {
        trigger: ".grid--circle",
        toggleActions: "restart pause pause pause",
        scrub: 1,
        start: "top center",
      },
    })

    tlCircles.to(".business--circle--bg-1", { rotation: 360 }, 0)
    tlCircles.to(".business--circle--bg-2", { rotation: 300 }, 0)
    tlCircles.to(".business--circle--bg-3", { rotation: 260 }, 0)
    tlCircles.to(".business--circle--bg-4", { rotation: 200 }, 0)
    tlCircles.to(".business--circle--bg-5", { rotation: 160 }, 0)
    tlCircles.to(".business--circle--bg-6", { rotation: 100 }, 0)
  }

  // Animation: Mission
  const missionIllios = document.querySelector(".mission--illios")
  if (missionIllios) {
    const tlMission = gsap.timeline({
      scrollTrigger: {
        trigger: ".mission--illios",
        start: "top 700px center",
        end: "bottom 500px",
      },
    })
    tlMission.from(".mission--illio-1", {
      duration: 0.5,
      y: "100",
    })
    tlMission.from(
      ".mission--illio-2",
      {
        duration: 0.5,
        y: "200",
      },
      "0"
    )
  }

  // Animation: Grows
  const gridGrows = document.querySelector(".grid--grows")
  if (gridGrows) {
    const tlGrows = gsap.timeline({
      scrollTrigger: {
        trigger: ".grid--grows",
        start: "top 700px center",
      },
    })
    tlGrows.from(".grid--grows--cell", {
      duration: 0.5,
      opacity: "0",
      y: "50",
      stagger: {
        amount: 0.25,
      },
    })
  }

  // Animation: Quotes
  const gridQuotes = document.querySelector(".grid--quad--quotes")
  if (gridQuotes) {
    const tlQuotes = gsap.timeline({
      scrollTrigger: {
        trigger: ".grid--quad--quotes",
        start: "top 700px center",
      },
    })
    tlQuotes.from(".grid--quad--quotes li", {
      duration: 0.5,
      opacity: "0",
      y: "50",
      stagger: {
        amount: 0.25,
      },
    })
  }

  // Animation: Hero: Individuals
  const heroPro = document.querySelector(".hero--pro")
  if (heroPro) {
    const tlHeroPro = gsap.timeline({
      autoRemoveChildren: true,
      scrollTrigger: {
        trigger: ".home--pro",
        start: "top center",
      },
    })
    tlHeroPro.from(
      ".hero--pro--bg-1",
      {
        duration: 0.5,
        x: "-200",
      },
      0.25
    )
    tlHeroPro.from(
      ".hero--pro--bg-2",
      {
        duration: 0.5,
        x: "200",
      },
      0.5
    )
    tlHeroPro.from(
      ".hero--pro--bg-3",
      {
        duration: 0.5,
        x: "100",
      },
      0.5
    )
  }

  // Animation: Custom
  const gridCustomize = document.querySelector(".grid--customize")
  if (gridCustomize) {
    const tlGridCustomize = gsap.timeline({
      scrollTrigger: {
        trigger: ".grid--customize",
        start: "top 500px center",
      },
    })
    tlGridCustomize.from(".grid--customize .grid-1", {
      duration: 0.5,
      //y: "100",
      opacity: 0.4,
    })
    tlGridCustomize.from(
      ".grid--customize .grid-2",
      {
        duration: 0.5,
        //y: "100",
        opacity: 0.4,
      },
      "-=0.25"
    )
    const tlGridTable = gsap.timeline({
      scrollTrigger: {
        trigger: ".grid--customize .grid-4",
        start: "top center",
      },
    })
    tlGridTable.from(
      "#b-circles",
      {
        duration: 0.4,
        y: "20",
        opacity: 0,
      },
      0
    )
    tlGridTable.from(
      "#b-slack",
      {
        duration: 0.4,
        y: "20",
        opacity: 0,
      },
      "-=0.25"
    )
    tlGridTable.from(
      "#b-evernote",
      {
        duration: 0.4,
        y: "20",
        opacity: 0,
      },
      "-=0.25"
    )
  }

  const counting = document.querySelector(".counting")
  if (counting) {
    const tlCounting = gsap.timeline({
      scrollTrigger: {
        trigger: ".counting",
        start: "top 700px center",
      },
    })
    let count = { val: 200 }
    let newCount = 817
    tlCounting.to(count, 10, {
      val: newCount,
      roundProps: "val",
      onUpdate() {
        document.querySelector(".count-up-100").innerHTML = count.val
      },
    })

    const tlCountingScrub = gsap.timeline({
      scrollTrigger: {
        trigger: ".counting",
        start: "top 700px center",
      },
    })
    tlCountingScrub.to(".bg--counting", { x: "-15%" })
  }
}
